import Theme from '@adsk/alloy-react-theme';

export const pillStyle = (valid) => ({
  padding: '2px 8px',
  margin: '0 5px 5px 0',
  color: Theme.colors.white,
  backgroundColor: valid ? Theme.colors.adskBlue500 : Theme.colors.red500,
  borderRadius: 14,
  border: 'none',
  alignItems: 'center',
  cursor: 'default',
});
